export default [{
  name: 'wiwap',
  namespaced: true,
  state: {
    model: {
      Pessoa: {
        PessoaDadosContato: {},
        PessoaEndereco: {},
        PessoaQualificacao: {}
      },
      Parcela: {},
    },
    dadosIniciais: {}
  },
  mutations: {
    model (state, obj) {
      state.model = obj
    },
    dadosIniciais (state, obj) {
      state.dadosIniciais = obj
    }
  },
  getters: {
    model (state) {
      return state.model
    },
    dadosIniciais (state) {
      return state.dadosIniciais
    }
  },
  actions: {
    clearModel ({ commit }) {
      const data = {
        Pessoa: {
          PessoaDadosContato: {},
          PessoaEndereco: {},
          PessoaQualificacao: {}
        },
        Parcela: {},
        PessoaDadosContato: {}
      }
      commit('model', data)
    }
  },
}]
